import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NotificationComponent } from './notification.component';
import { NotificationService } from './notification.service';
import { NotificationContentComponent } from './notification-content/notification-content.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { KngLoaderModule } from 'kinetic-angular';
import { AnalyticsModule } from '../../services/analytics/analytics.module';
const routes: Routes = [
	{ path: '', component: NotificationComponent, data: { title: 'Notification' } }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class NotificationRoutingModule {}
@NgModule({
	declarations: [
		NotificationComponent,
		NotificationContentComponent
	],
	imports: [ CommonModule, NotificationRoutingModule, NgxPaginationModule, KngLoaderModule, AnalyticsModule ],
	exports: [
		NotificationComponent
	],
	providers: [
		NotificationService
	]
})
export class NotificationModule { }
